import { createFileRoute } from "@tanstack/react-router";
import InvoiceOcrToolPage from "@/features/public/pages/tools/invoice-ocr";

export const Route = createFileRoute("/(public)/_public/tools/invoice-ocr")({
  component: InvoiceOcrToolPage,
});
